import React, { ReactElement, useContext } from "react";
import { ThemeContext, ThemeProvider } from "styled-components";

import { Heading, Container, StyledTextBlock } from "./FormInfoBox.styled";
import FormInfoBoxProps from "./FormInfoBoxProps";

import useIsInEditMode from "../../hooks/useIsInEditMode";
import { addEditAttributes } from "../../utils/episerver";

const FormInfoBox = ({
    identifier,
    className,
    theme,
    heading,
    mainBody,
}: FormInfoBoxProps): ReactElement => {
    const isInEditMode = useIsInEditMode();

    heading = heading || (isInEditMode ? "" : undefined);
    mainBody = mainBody || (isInEditMode ? [{}] : undefined);
    const themeContext = useContext(ThemeContext);
    if (!theme) theme = (themeContext && themeContext.theme) || "lightgray";

    return (
        <ThemeProvider theme={{ theme: theme }}>
            <Container key={identifier} className={className}>
                {heading && (
                    <Heading
                        {...addEditAttributes("Heading")}
                        dangerouslySetInnerHTML={{ __html: heading }}
                    />
                )}
                {mainBody && (
                    <StyledTextBlock
                        content={mainBody}
                        areaName="mainBody"
                        {...addEditAttributes("MainBody")}
                    />
                )}
            </Container>
        </ThemeProvider>
    );
};

export default React.memo(FormInfoBox);
